<div class="dna-dp-wrap">
  <input class="dna-input dna-dp-input"
         [placeholder]="placeholder"
         [disabled]="disabled"
         mask="00/00/0000"
         [ngModel]="value"
         (ngModelChange)="onText($event)"
         (click)="openCalendar()">

  <button type="button" class="dna-dp-toggle" (click)="toggle()" [disabled]="disabled" title="Selecionar data">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  </button>

  <div class="dna-dp-popup" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="dna-dp-header">
      <button type="button" class="dna-dp-nav" (click)="prevMonth($event)">‹</button>
      <span class="dna-dp-title">{{ monthLabel }}</span>
      <button type="button" class="dna-dp-nav" (click)="nextMonth($event)">›</button>
    </div>

    <div class="dna-dp-weekdays">
      <span *ngFor="let w of weekDays">{{ w }}</span>
    </div>

    <div class="dna-dp-grid">
      <ng-container *ngFor="let c of cells">
        <span *ngIf="c === null" class="dna-dp-empty"></span>
        <div *ngIf="c !== null" role="button" tabindex="0" class="dna-dp-cell"
             [class.selected]="isSelected(c)"
             [class.today]="isToday(c) && !isSelected(c)"
             (click)="selectDay(c)"
             (keydown.enter)="selectDay(c)">{{ c }}</div>
      </ng-container>
    </div>
  </div>
</div>
